import { Checkbox, DefaultButton, Pivot, PivotItem, Spinner, Stack, Text } from '@fluentui/react';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import PersonalSettingsState from '../../../state/PersonalSettingsState';
import { SearchScopesListState } from '../search-scopes/SearchScopesList';
import SearchScopesList from '../search-scopes/SearchScopesList';
import { ManagedPropertiesListState } from '../search-properties/ManagedPropertiesList';
import ManagedPropertiesList from '../search-properties/ManagedPropertiesList';

interface ISearchAdminPageProps {
	settingsState: PersonalSettingsState;
	searchScopes: SearchScopesListState;
	managedProps: ManagedPropertiesListState;
}

function SearchAdminPage({ settingsState, searchScopes, managedProps }: ISearchAdminPageProps) {

	useEffect(() => {
		settingsState.ensureLoaded();
	}, [settingsState]);

	if (settingsState.loading || !settingsState.settings) {
		return <Spinner />;
	}

	return (
		<Pivot>
			<PivotItem headerText='Scopes'>
				<SearchScopesList state={searchScopes} />
			</PivotItem>
			<PivotItem headerText='Properties'>
				<ManagedPropertiesList state={managedProps} />
			</PivotItem>
			<PivotItem headerText='General'>
				<Stack tokens={{ childrenGap: 10 }} style={{ marginTop: 10 }}>
					<Checkbox
						label='Enable site search'
						checked={settingsState.settings.enableSiteSearch}
						onChange={(_, checked) => settingsState.updateEnableSiteSearch(!!checked)}
					/>
					<Text>When enabled, SharePoint sites will be included in global search results for all users.</Text>
					<Stack horizontal>
						<DefaultButton disabled={!settingsState.searchChangesMade} onClick={() => settingsState.saveSearchChanges()}>Apply</DefaultButton>
					</Stack>
				</Stack>
			</PivotItem>
		</Pivot>
	);
}

export default observer(SearchAdminPage);
